import { cn } from "@tine/designsystem-utils";
import type React from "react";

interface PublishDateProps {
   createdAt: string;
   updatedAt: string;
   className?: string;
}

const PublishDate: React.FC<PublishDateProps> = ({ createdAt, updatedAt, className }) => (
   <p className={cn("text-sm lg:text-lg font-light", className)}>
      Publisert {new Date(createdAt).toLocaleDateString("no-NO")} | Oppdatert {new Date(updatedAt).toLocaleDateString("no-NO")}
   </p>
);

export default PublishDate;
